export const isWorkoutReplaced = (workout) => {
  return workout && workout.status === 'replaced';
}

export const isWorkoutExpired = (workout) => {
  return workout && workout.due_at && new Date(workout.due_at) < new Date()
    && workout.status !== undefined
    && workout.status !== "complete"
    && workout.status !== "rest"
    && !isWorkoutReplaced(workout);
};

export const isWorkoutComplete = (workout) => {
  return workout && workout.status === 'complete';
}

export const isWorkoutRest = (workout) => {
  return workout && workout.status === 'rest';
}

export const isWorkoutEditable = (workout) => {
  return workout && !isWorkoutExpired(workout) && !isWorkoutComplete(workout) && !isWorkoutRest(workout) && !isWorkoutReplaced(workout);
};

export const isWorkoutOngoing = (workout) => {
  return workout && !isWorkoutExpired(workout) && workout.status === 'ongoing';
}
